// extracted by mini-css-extract-plugin
export default {"orderItemContainer":"wallet_orderItemContainer__BmdJ8","loadMoreBtn":"wallet_loadMoreBtn__jbQkZ"};